import React from "react";
import SeoHead from "../../../components/SeoHead";
import { Global, Collection } from "@sourceflow-uk/sourceflow-sdk";
import MainBanner from "../../../components/MainBanner";
import ImageWithTextBanner from "../../../components/ImageWithTextBanner";
import ImageWithTextWithOverlay from "../../../components/ImageWithTextWithOverlay";
import LatestTestimonials from "../../../components/LatestTestimonials";
import LatestNews from "../../../components/LatestNews";

export default function ExecutiveSearchPage({
    global,
    all_news
}) {
    return (
        <>
            <SeoHead
                page_name={`Executive & Technical Search | Science, Engineering & Life Science Recruitment, Jobs & Staffing | SRG`}
                canonical_link={`/business-solutions/executive-search`}
                description={`Find top STEM talent with Search by SRG’s innovative executive and technical search solutions. Our data-driven approach ensures the perfect fit for your organisation.`}
            />
            <MainBanner
                global={global}
                pathPrefix={`executive_search_page.main_banner`}
                customClass={``}
                h1_content={`Executive & Technical Search`}
                content={
                <>
                    <p>Search by SRG is a leading executive recruitment service connecting you with the best middle and senior technical heads and managers in STEM fields. Our data-driven executive and technical search solutions deliver tailored recruitment strategies for your organisation's success.</p>
                </>
                }
                imageURL1={`/site-assets/images/main-banner.jpg`}
                imageALT1={`Main Banner`}
                imageURL2={`/site-assets/images/main-banner-overlay.jpg`}
                imageALT2={`Overlay Main Banner`}
                editableContent={true}
                displayImage1={false}
                buttonTitle={'Get In Touch'}
                popUpModal_1={true}
                popUpModal_1_form_id={'6c9ee93b-e8d3-43f8-b497-83ed2206fdc7'}
                dialog_content_1={'Contact Us'}
                successPageUrl={'/business-solutions/submission-success/'}
               
            />
            <ImageWithTextWithOverlay
                global={global}
                pathPrefix={`executive_search_page.image_with_text_with_overlay`}
                customClass={`py-5`}
                backgroundColor={"#ffffff"}
                content={
                <>
                    <h2>Achieve Results with our Executive and Technical Search Solutions</h2>
                    <p>
                        Driven by data intelligence, our expertise in STEM recruitment and resourcing makes Search by SRG a market-leading service designed to find, hire and retain top talent for STEM businesses.
                    </p>
                    <p>
                        As a dedicated executive search team, we offer innovative solutions to identify unique skills, deliver on project-based hiring and secure senior technical appointments across various industries, including pharmaceutical, life science, medical, AI, engineering and MedTech and more.
                    </p>
                </>
                }
                imageURL={`/site-assets/images/executive-stem-recruitment.png`}
                imageALT={`Achieve Results with our Executive and Technical Search Solutions`}
                popUpModal_1={false}
            />
            <ImageWithTextBanner
                global={global}
                pathPrefix={`executive_search_page.image_with_text_banner`}
                customClass={``}
                content={
                <>
                    <h3>Our Approach to Executive Search</h3>
                    <p>Search by SRG is flexible, transparent and agile, offering a range of specialist, tailored solutions including:</p>
                    <ul>
                        <li>Technical and Executive Search</li>
                        <li>Market insights and reporting</li>
                        <li>Salary insights and benchmarking</li>
                        <li>High-end interim and consultants</li>
                        <li>Project recruitment campaigns</li>
                        <li>Equality, Diversity and Inclusion (EDI)</li>
                    </ul>
                    <p>We get to know your organisation’s culture, values, and aspirations, then assign dedicated experts to develop a tailored strategy. Our data-driven recruitment process offers real-time insights and transparency, ensuring you find the right fit for your company.</p>
                </>
                }
                imageURL={`/site-assets/images/diverse-executive-recruitment.png`}
                imageALT={`Our Approach to Executive Search`}
            />
            <ImageWithTextWithOverlay
                global={global}
                pathPrefix={`executive_search_page.image_with_text_with_overlay_2`}
                customClass={`p-5`}
                backgroundColor={"#ffffff"}
                content={
                <>
                    <h2>Why Search by SRG?</h2>
                    <p>
                        Working with Search by SRG means driving your project forward with the passion and knowledge of dedicated experts from the STEM industries and executive recruitment. The benefits of our executive solutions include:
                    </p>
                    <ul className="mb-5">
                        <li>A dedicated research team with every project</li>
                        <li>Access to real-time market intelligence and data driven solutions</li>
                        <li>Insights from technical and personality assessment tools</li>
                        <li>Dedicated project management support and weekly review meetings</li>
                        <li>Variable attraction campaigns tailored to your needs</li>
                        <li>The knowledge, passion and drive of our experts</li>
                    </ul>
                    <h2>Partner with Search by SRG Today</h2>
                    <p>Experience the difference our expertise can make. Get in touch to discuss your executive and technical search needs and discover how we can help your business thrive.</p>
                </>
                }
                imageURL={`/site-assets/images/executive-search-recruitment.png`}
                imageALT={`Why Search by SRG?`}
                buttonTitle2={`View Latest Jobs`}
                buttonLink2={`/jobs/`}
                buttonTitle={`Contact Us`}
                buttonLink={`/contact-us/`}
                popUpModal_1={true}
                popUpModal_1_form_id={`6c9ee93b-e8d3-43f8-b497-83ed2206fdc7`}
                successPageUrl={`/business-solutions/submission-success`}
            />
            <LatestTestimonials
                global={global}
                pathPrefix={`executive_search_page.latest_testimonials`}
                customClass={`py-5`}
                content={
                <>
                    <h2>Search by SRG Testimonials</h2>
                </>
                }
                post={[
                    {
                        content: "<p>It was a pleasure working with you, you made recruitment actually interesting to me, and as soon as I'm in need again I will definitely be reaching out to you.</p>",
                        title: "HR Business Partner, Medical Technology & Services"
                    },
                    {
                        content: "<p>The recruitment journey was comprehensive, encompassing interviews with key executives, a meticulous personality assessment, and thorough reference checks. Throughout each stage, the recruiter provided invaluable guidance and support, ensuring that I was well-prepared and confident.</p>",
                        title: "Medical Science Liaison, Pharma"
                    },
                    {
                        content: "<p>I would highly recommend the Search by SRG team and their process to any company, I would have no hesitation in using the team again.</p>",
                        title: "Technical Manager - Global Formulation Services"
                    },
                    {
                        content: "<p>Very dedicated and a pleasure to work with.</p>",
                        title: "Medical Affairs Director, Pharma"
                    }
                ]}
                swiperID={`TestimonialsSwiper`}
            />
            <LatestNews
                global={global}
                pathPrefix={`executive_search_page.latest_news`}
                customClass={`py-5 grayGradientBg top-rounded-radius`}
                post={all_news}
                content={
                <>
                    <h2>The Lorien Pulse: Latest News, Events, and Insights</h2>
                    <p>
                        Our tech expertise and partner-led approach allows us to deliver
                        highly successful results for our clients so they can attract and
                        retain unique talent for their business. Explore our latest
                        collection of case studies, news, events, and insights
                    </p>
                </>
                }
                buttonLink={`/blog/`}
                buttonTitle={`View All Insights`}
            />
        </>
    )
}

export async function getStaticProps({ params }) {
    const global = (await Global()).toJson();

    const news = (await Collection("news")).filter(function (post) {
        return post.country?.en == "United Kingdom" || post.country?.en == "All";
    });

    const all_news = news.orderBy("date").getItems().slice(0, 8);

    return {
        props: {
            global,
            all_news
        }
    };
}
